module.exports = __webpack_public_path__ + "static/media/elm.91a54b74.png";